export const works = [
  {
    id: "WK-0001",
    title: "蒼穹のカナタ",
    alternativeTitles: ["そうきゅうのかなた", "蒼穹の彼方"],
    searchKeywords: ["冒険", "空", "旅", "アマノハルカ"],
    audienceType: "male",
    contentType: "video",
    creator: "天野遥",
    performers: ["桐生蓮", "白石澪"],
    maker: "蒼流社",
    series: "蒼穹シリーズ",
    releaseDate: "2026-08-21",
    addedAt: "2026-10-12T09:20:00+09:00",
    updatedAt: "2026-10-15T18:40:00+09:00",
    tags: ["ファンタジー", "冒険", "感動", "長編"],
    description:
      "空に浮かぶ島々を渡る旅人と、失われた地図を追う少女の物語。静かな会話と雄大な景色で綴られるロードムービー的作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20artwork%20of%20a%20vast%20open%20sky%20above%20layered%20mountain%20silhouettes%20in%20deep%20steel%20blue%20and%20pale%20sand%20tones%2C%20soft%20grain%20texture%2C%20minimal%20geometric%20composition%2C%20calm%20atmospheric%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0001&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 1980,
    onSale: false,
    rating: 4.4,
    reviewCount: 128,
    rankingScore: 96,
    affiliateUrl: "https://example.com/store/wk-0001",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-10-15T18:40:00+09:00",
  },
  {
    id: "WK-0002",
    title: "鋼鉄のレクイエム",
    alternativeTitles: ["こうてつのレクイエム"],
    searchKeywords: ["ロボット", "戦争", "重厚"],
    audienceType: "male",
    contentType: "manga",
    creator: "黒沢巌",
    performers: [],
    maker: "黒曜舎",
    series: "鋼鉄シリーズ",
    releaseDate: "2026-06-05",
    addedAt: "2026-09-20T11:00:00+09:00",
    updatedAt: "2026-10-10T10:15:00+09:00",
    tags: ["アクション", "SF", "ダーク", "シリーズ"],
    description:
      "戦いの終わった街で、傷ついた機械と少年が静かに暮らしはじめる。派手さよりも喪失と再生を描いた硬質なSF漫画です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20industrial%20artwork%20in%20dark%20graphite%20grey%20with%20ember%20orange%20accents%2C%20layered%20metal%20plates%20and%20geometric%20shapes%2C%20subtle%20rust%20texture%2C%20dramatic%20editorial%20composition%2C%20minimal%20clean%20background%2C%20no%20text&width=600&height=800&seq=wk-0002&orientation=portrait",
    sampleVideoUrl: null,
    price: 880,
    onSale: true,
    rating: 4.1,
    reviewCount: 76,
    rankingScore: 88,
    affiliateUrl: "https://example.com/store/wk-0002",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-10-10T10:15:00+09:00",
  },
  {
    id: "WK-0003",
    title: "深夜0時の探偵",
    alternativeTitles: ["しんやれいじのたんてい", "深夜零時の探偵"],
    searchKeywords: ["ミステリ", "夜", "連続ドラマ"],
    audienceType: "male",
    contentType: "video",
    creator: "三好律",
    performers: ["早瀬迅", "小柳千尋"],
    maker: "ネクサス出版",
    series: null,
    releaseDate: "2026-05-15",
    addedAt: "2026-08-02T15:30:00+09:00",
    updatedAt: "2026-09-30T12:00:00+09:00",
    tags: ["ミステリー", "サスペンス", "短編"],
    description:
      "午前0時にだけ依頼を受ける探偵と、彼のもとに届く差出人不明の手紙。一話完結で追いやすい本格ミステリーです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20noir%20artwork%20with%20midnight%20blue%20shadows%2C%20a%20single%20warm%20amber%20glow%20in%20the%20center%2C%20soft%20rain%20grain%20texture%2C%20minimal%20urban%20geometric%20shapes%2C%20moody%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0003&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 1200,
    onSale: false,
    rating: 3.9,
    reviewCount: 42,
    rankingScore: 82,
    affiliateUrl: "https://example.com/store/wk-0003",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0004",
    title: "アルゴリズム・ラブ",
    alternativeTitles: ["あるごりずむらぶ"],
    searchKeywords: ["恋愛", "アプリ", "すれ違い"],
    audienceType: "male",
    contentType: "manga",
    creator: "一ノ瀬ミナ",
    performers: [],
    maker: "リーフ出版",
    series: null,
    releaseDate: "2026-09-30",
    addedAt: "2026-10-14T08:10:00+09:00",
    updatedAt: "2026-10-14T19:25:00+09:00",
    tags: ["恋愛", "コメディ", "青春"],
    description:
      "マッチングアプリの開発者と、そのアプリを使いこなせない青年。理屈と感情がすれ違う軽快なラブコメディです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20playful%20geometric%20artwork%20with%20soft%20coral%20circles%20on%20cool%20slate%20blue%20grid%2C%20clean%20flat%20shapes%2C%20subtle%20paper%20texture%2C%20modern%20minimal%20editorial%20design%2C%20gentle%20contrast%2C%20no%20text&width=600&height=800&seq=wk-0004&orientation=portrait",
    sampleVideoUrl: null,
    price: 660,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: 74,
    affiliateUrl: "https://example.com/store/wk-0004",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0005",
    title: "落城のあとで",
    alternativeTitles: ["らくじょうのあとで"],
    searchKeywords: ["戦国", "歴史", "城"],
    audienceType: "male",
    contentType: "ebook",
    creator: "綾瀬玄",
    performers: [],
    maker: "燈文庫",
    series: "戦国残影",
    releaseDate: "2025-11-20",
    addedAt: "2026-07-11T13:45:00+09:00",
    updatedAt: "2026-09-12T09:05:00+09:00",
    tags: ["歴史", "ドラマ", "長編"],
    description:
      "陥落した城に残された下級武士の視点から、勝者に語られない戦後を描く長編。静かな筆致と緻密な時代描写が特徴です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20historical%20artwork%20in%20ash%20grey%20and%20muted%20crimson%2C%20layered%20ink%20wash%20shapes%20suggesting%20castle%20walls%2C%20aged%20paper%20texture%2C%20restrained%20editorial%20composition%2C%20quiet%20melancholic%20mood%2C%20no%20text&width=600&height=800&seq=wk-0005&orientation=portrait",
    sampleVideoUrl: null,
    price: 1500,
    onSale: true,
    rating: 4.6,
    reviewCount: 210,
    rankingScore: 91,
    affiliateUrl: "https://example.com/store/wk-0005",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-09-12T09:05:00+09:00",
  },
  {
    id: "WK-0006",
    title: "零号機の記憶",
    alternativeTitles: ["ぜろごうきのきおく"],
    searchKeywords: ["SF", "機械", "記憶"],
    audienceType: "male",
    contentType: "video",
    creator: "五十嵐翔",
    performers: ["神谷蒼"],
    maker: "蒼流社",
    series: "零号機",
    releaseDate: "2026-03-08",
    addedAt: "2026-06-18T16:20:00+09:00",
    updatedAt: "2026-08-25T11:40:00+09:00",
    tags: ["SF", "アクション", "ロボット"],
    description:
      "使われなくなった試作機が、記録に残らない一日を再生する。静かなSFとして記憶と所有を考えさせる作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20science%20fiction%20artwork%20with%20brushed%20silver%20surfaces%20and%20pale%20cyan%20light%20streaks%2C%20concentric%20geometric%20rings%2C%20fine%20grain%20texture%2C%20cool%20minimal%20editorial%20illustration%2C%20clean%20background%2C%20no%20text&width=600&height=800&seq=wk-0006&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 2800,
    onSale: false,
    rating: 4.0,
    reviewCount: 64,
    rankingScore: 79,
    affiliateUrl: "https://example.com/store/wk-0006",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0007",
    title: "廃線駅の幽霊",
    alternativeTitles: ["はいせんえきのゆうれい"],
    searchKeywords: ["ホラー", "駅", "心霊"],
    audienceType: "male",
    contentType: "manga",
    creator: "雨宮たすく",
    performers: [],
    maker: "黒曜舎",
    series: null,
    releaseDate: "2026-07-19",
    addedAt: "2026-08-20T10:00:00+09:00",
    updatedAt: "2026-10-16T21:10:00+09:00",
    tags: ["ホラー", "ミステリー", "短編"],
    description:
      "取り壊しの決まった廃駅に、毎晩同じ時刻の列車が到着する。短編でまとまった、湿った空気のホラー作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20misty%20horror%20artwork%20in%20desaturated%20moss%20green%20and%20grey%2C%20faint%20geometric%20platform%20silhouette%2C%20drifting%20fog%20texture%2C%20subtle%20cold%20light%2C%20quiet%20unsettling%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0007&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 480,
    onSale: false,
    rating: 3.6,
    reviewCount: 25,
    rankingScore: 68,
    affiliateUrl: "https://example.com/store/wk-0007",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0008",
    title: "都市伝説ファイル",
    alternativeTitles: ["としでんせつふぁいる"],
    searchKeywords: ["オカルト", "都市伝説", "短編集"],
    audienceType: "male",
    contentType: "ebook",
    creator: "堂島蓮司",
    performers: [],
    maker: "ネクサス出版",
    series: "都市伝説ファイル",
    releaseDate: "2026-02-14",
    addedAt: "2026-05-09T09:30:00+09:00",
    updatedAt: "2026-09-05T14:50:00+09:00",
    tags: ["ホラー", "オカルト", "短編集"],
    description:
      "SNSで広がる小さな噂を取材する記録集。読み切り形式で、日常のすぐ隣にある違和感を集めた一冊です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20grainy%20collage%20artwork%20in%20charcoal%20black%20and%20dusty%20beige%2C%20layered%20torn%20paper%20shapes%20and%20faint%20concentric%20lines%2C%20analog%20noise%20texture%2C%20mysterious%20minimal%20editorial%20composition%2C%20no%20text&width=600&height=800&seq=wk-0008&orientation=portrait",
    sampleVideoUrl: null,
    price: 0,
    onSale: false,
    rating: 3.4,
    reviewCount: 18,
    rankingScore: 60,
    affiliateUrl: "https://example.com/store/wk-0008",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0009",
    title: "剣客ふたたび",
    alternativeTitles: ["けんかくふたたび"],
    searchKeywords: ["剣士", "時代劇", "再起"],
    audienceType: "male",
    contentType: "manga",
    creator: "大和誠",
    performers: [],
    maker: "みなも書房",
    series: "剣客シリーズ",
    releaseDate: "2024-12-01",
    addedAt: "2026-04-03T12:00:00+09:00",
    updatedAt: "2026-07-22T17:20:00+09:00",
    tags: ["歴史", "アクション", "シリーズ"],
    description:
      "刀を置いた男が、もう一度だけ剣を取る。王道の時代劇を、丁寧な人物描写で描き直したシリーズ作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20ink%20brush%20artwork%20in%20deep%20indigo%20and%20warm%20ivory%2C%20bold%20sweeping%20strokes%20suggesting%20a%20blade%2C%20textured%20washi%20paper%20background%2C%20minimal%20traditional%20japanese%20editorial%20composition%2C%20no%20text&width=600&height=800&seq=wk-0009&orientation=portrait",
    sampleVideoUrl: null,
    price: 990,
    onSale: false,
    rating: 4.3,
    reviewCount: 154,
    rankingScore: 85,
    affiliateUrl: "https://example.com/store/wk-0009",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-07-22T17:20:00+09:00",
  },
  {
    id: "WK-0010",
    title: "星屑の航海士",
    alternativeTitles: ["ほしくずのこうかいし"],
    searchKeywords: ["宇宙", "航海", "星空"],
    audienceType: "male",
    contentType: "video",
    creator: "星空プロダクション",
    performers: ["水城圭"],
    maker: "カナリアブックス",
    series: null,
    releaseDate: "2026-09-11",
    addedAt: "2026-09-12T10:40:00+09:00",
    updatedAt: "2026-10-13T20:30:00+09:00",
    tags: ["SF", "ドラマ", "感動"],
    description:
      "星図を持たない航海士が、目的地だけを頼りに航行する。静かな音楽と映像で構成された、余韻の長い作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20space%20artwork%20in%20deep%20navy%20blue%20with%20scattered%20warm%20gold%20dots%2C%20soft%20layered%20nebula%20gradients%2C%20fine%20film%20grain%2C%20elegant%20minimal%20editorial%20illustration%20with%20quiet%20sense%20of%20scale%2C%20no%20text&width=600&height=800&seq=wk-0010&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 3300,
    onSale: false,
    rating: 4.7,
    reviewCount: 96,
    rankingScore: 98,
    affiliateUrl: "https://example.com/store/wk-0010",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-10-13T20:30:00+09:00",
  },
  {
    id: "WK-0011",
    title: "バンドマンの夜",
    alternativeTitles: ["ばんどまんのよる"],
    searchKeywords: ["音楽", "ライブ", "ドラマCD"],
    audienceType: "male",
    contentType: "voice",
    creator: "音羽レコード",
    performers: ["夜久バンド"],
    maker: "音羽レコード",
    series: null,
    releaseDate: "2025-08-08",
    addedAt: "2026-03-14T11:15:00+09:00",
    updatedAt: "2026-06-19T16:00:00+09:00",
    tags: ["音楽", "ドラマ", "ドラマCD"],
    description:
      "小さなライブハウスを舞台にした音楽ドラマCD。演奏シーンの音作りと、メンバー同士の会話の温度感が見どころです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20music%20event%20artwork%20with%20warm%20amber%20stage%20lights%20against%20deep%20charcoal%2C%20soft%20blurred%20geometric%20shapes%2C%20film%20grain%20texture%2C%20moody%20minimal%20editorial%20poster%20style%2C%20no%20text&width=600&height=800&seq=wk-0011&orientation=portrait",
    sampleVideoUrl: null,
    price: 2200,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: null,
    affiliateUrl: "https://example.com/store/wk-0011",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0012",
    title: "逆転の棋譜",
    alternativeTitles: ["ぎゃくてんのきふ"],
    searchKeywords: ["将棋", "頭脳戦", "勝負"],
    audienceType: "male",
    contentType: "manga",
    creator: "城戸悠",
    performers: [],
    maker: "リーフ出版",
    series: "棋譜シリーズ",
    releaseDate: "2026-04-22",
    addedAt: "2026-07-07T10:05:00+09:00",
    updatedAt: "2026-10-08T13:35:00+09:00",
    tags: ["サスペンス", "頭脳戦", "シリーズ"],
    description:
      "一手ごとに退路が消えていく、盤上の心理戦。対局の緊張を丁寧に描いた本格頭脳戦漫画です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20monochrome%20chessboard%20artwork%20with%20strong%20graphic%20contrast%2C%20geometric%20squares%20and%20circles%2C%20fine%20paper%20texture%2C%20sharp%20minimal%20editorial%20composition%2C%20cool%20grey%20palette%2C%20no%20text&width=600&height=800&seq=wk-0012&orientation=portrait",
    sampleVideoUrl: null,
    price: 780,
    onSale: true,
    rating: 4.2,
    reviewCount: 88,
    rankingScore: 81,
    affiliateUrl: "https://example.com/store/wk-0012",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0013",
    title: "荒野のカウントダウン",
    alternativeTitles: ["こうやのかうんとだうん"],
    searchKeywords: ["荒野", "逃走", "アクション"],
    audienceType: "male",
    contentType: "video",
    creator: "榊原剛",
    performers: ["黒木隼"],
    maker: "ネクサス出版",
    series: null,
    releaseDate: "2026-10-02",
    addedAt: "2026-10-15T09:00:00+09:00",
    updatedAt: "2026-10-17T08:20:00+09:00",
    tags: ["アクション", "サスペンス", "長編"],
    description:
      "砂漠を走る一台の車と、残り時間だけが示される追跡劇。台詞を抑えた構成で緊張感を保つアクション作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20desert%20artwork%20with%20burnt%20orange%20and%20sand%20tones%2C%20layered%20dune%20shapes%20and%20a%20thin%20dark%20horizon%20line%2C%20warm%20dust%20texture%2C%20cinematic%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0013&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 1980,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: 70,
    affiliateUrl: "https://example.com/store/wk-0013",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0014",
    title: "春待ちのカフェテラス",
    alternativeTitles: ["はるまちのかふぇてらす"],
    searchKeywords: ["カフェ", "恋", "春"],
    audienceType: "female",
    contentType: "manga",
    creator: "小春ひより",
    performers: [],
    maker: "アトリエ・ノア",
    series: "カフェテラス",
    releaseDate: "2026-03-12",
    addedAt: "2026-04-10T10:20:00+09:00",
    updatedAt: "2026-09-26T15:10:00+09:00",
    tags: ["恋愛", "日常", "青春"],
    description:
      "開店準備中の小さなカフェで、店長と常連客の距離が少しずつ縮まっていく。季節の移ろいを丁寧に描いた連載です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20soft%20romantic%20artwork%20in%20blush%20rose%20and%20warm%20cream%2C%20layered%20rounded%20shapes%20suggesting%20cafe%20light%2C%20gentle%20paper%20texture%2C%20clean%20minimal%20editorial%20illustration%20with%20airy%20spacing%2C%20no%20text&width=600&height=800&seq=wk-0014&orientation=portrait",
    sampleVideoUrl: null,
    price: 660,
    onSale: false,
    rating: 4.5,
    reviewCount: 186,
    rankingScore: 94,
    affiliateUrl: "https://example.com/store/wk-0014",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-09-26T15:10:00+09:00",
  },
  {
    id: "WK-0015",
    title: "花とゆめの約束",
    alternativeTitles: ["はなとゆめのやくそく"],
    searchKeywords: ["花", "約束", "ファンタジー"],
    audienceType: "female",
    contentType: "ebook",
    creator: "一花みのり",
    performers: [],
    maker: "カナリアブックス",
    series: null,
    releaseDate: "2026-09-25",
    addedAt: "2026-09-26T09:45:00+09:00",
    updatedAt: "2026-10-16T17:30:00+09:00",
    tags: ["恋愛", "ファンタジー", "短編集"],
    description:
      "花言葉を扱う小さな店を舞台にした短編集。一話ごとに完結し、眠る前に少しずつ読める優しい物語集です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20botanical%20artwork%20in%20pastel%20rose%20and%20sage%20green%2C%20delicate%20overlapping%20leaf%20and%20petal%20shapes%2C%20soft%20watercolor%20texture%2C%20elegant%20minimal%20editorial%20composition%20with%20light%20cream%20background%2C%20no%20text&width=600&height=800&seq=wk-0015&orientation=portrait",
    sampleVideoUrl: null,
    price: 880,
    onSale: false,
    rating: 4.2,
    reviewCount: 57,
    rankingScore: 89,
    affiliateUrl: "https://example.com/store/wk-0015",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-10-16T17:30:00+09:00",
  },
  {
    id: "WK-0016",
    title: "週末はあなたと",
    alternativeTitles: ["しゅうまつはあなたと"],
    searchKeywords: ["週末", "大人", "恋愛ドラマ"],
    audienceType: "female",
    contentType: "video",
    creator: "篠原ゆかり",
    performers: ["藤河千夏", "有栖川玲"],
    maker: "蒼流社",
    series: "週末シリーズ",
    releaseDate: "2026-07-04",
    addedAt: "2026-08-09T12:30:00+09:00",
    updatedAt: "2026-10-11T18:00:00+09:00",
    tags: ["恋愛", "ドラマ", "大人向け"],
    description:
      "平日は別々に暮らす二人が、週末だけ同じ時間を過ごす。距離を保ったまま近づいていく関係を描いた大人の恋愛ドラマです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20blush%20interior%20artwork%20with%20soft%20afternoon%20light%2C%20geometric%20window%20shapes%20and%20linen%20texture%2C%20muted%20rose%20and%20cream%20palette%2C%20calm%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0016&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 2500,
    onSale: true,
    rating: 3.8,
    reviewCount: 34,
    rankingScore: 77,
    affiliateUrl: "https://example.com/store/wk-0016",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0017",
    title: "月明かりの図書館",
    alternativeTitles: ["つきあかりのとしょかん"],
    searchKeywords: ["図書館", "夜", "幻想"],
    audienceType: "female",
    contentType: "manga",
    creator: "夜野つむぎ",
    performers: [],
    maker: "みなも書房",
    series: null,
    releaseDate: "2026-06-14",
    addedAt: "2026-07-01T14:00:00+09:00",
    updatedAt: "2026-09-18T19:45:00+09:00",
    tags: ["ファンタジー", "ミステリー", "静かな物語"],
    description:
      "閉館後の図書館で、返却期限の切れた本だけが語りかけてくる。静かな幻想と小さな謎を組み合わせた作品です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20dreamy%20library%20artwork%20in%20dusty%20rose%20and%20deep%20teal%2C%20tall%20vertical%20shapes%20suggesting%20bookshelves%2C%20pale%20moonlight%20glow%2C%20fine%20grain%20texture%2C%20quiet%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0017&orientation=portrait",
    sampleVideoUrl: null,
    price: 780,
    onSale: false,
    rating: 4.4,
    reviewCount: 112,
    rankingScore: 90,
    affiliateUrl: "https://example.com/store/wk-0017",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-09-18T19:45:00+09:00",
  },
  {
    id: "WK-0018",
    title: "恋するオフィス24時",
    alternativeTitles: ["こいするおふぃすにじゅうよじ"],
    searchKeywords: ["オフィス", "同僚", "ラブコメ"],
    audienceType: "female",
    contentType: "video",
    creator: "高瀬みずき",
    performers: ["朝比奈奏", "柊木亮"],
    maker: "ネクサス出版",
    series: null,
    releaseDate: "2026-08-29",
    addedAt: "2026-10-13T08:50:00+09:00",
    updatedAt: "2026-10-14T12:20:00+09:00",
    tags: ["恋愛", "コメディ", "オフィス"],
    description:
      "残業続きの部署で、仕事のできる同僚とだけは上手く話せない。テンポの良い会話で進むオフィスラブコメディです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20office%20romance%20artwork%20in%20soft%20coral%20and%20cool%20greige%2C%20clean%20geometric%20desk%20shapes%20and%20warm%20lamp%20glow%2C%20subtle%20paper%20texture%2C%20bright%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0018&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 1500,
    onSale: false,
    rating: 4.0,
    reviewCount: 71,
    rankingScore: 84,
    affiliateUrl: "https://example.com/store/wk-0018",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0019",
    title: "砂糖菓子の家",
    alternativeTitles: ["さとうがしのいえ"],
    searchKeywords: ["お菓子", "日常", "ほのぼの"],
    audienceType: "female",
    contentType: "ebook",
    creator: "白井ことり",
    performers: [],
    maker: "アトリエ・ノア",
    series: "お菓子シリーズ",
    releaseDate: "2025-12-20",
    addedAt: "2026-02-02T10:10:00+09:00",
    updatedAt: "2026-08-30T11:55:00+09:00",
    tags: ["日常", "ほのぼの", "短編集"],
    description:
      "小さなお菓子屋さんで交わされる、なんでもない会話の集まり。読後感の軽い短編集で、寝る前の一冊に向いています。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20pastel%20confectionery%20artwork%20in%20cream%20white%20and%20powder%20pink%2C%20stacked%20rounded%20shapes%20like%20small%20cakes%2C%20soft%20powder%20texture%2C%20gentle%20minimal%20editorial%20illustration%20with%20airy%20background%2C%20no%20text&width=600&height=800&seq=wk-0019&orientation=portrait",
    sampleVideoUrl: null,
    price: 0,
    onSale: false,
    rating: 3.9,
    reviewCount: 19,
    rankingScore: 63,
    affiliateUrl: "https://example.com/store/wk-0019",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0020",
    title: "星降る夜のレシピ",
    alternativeTitles: ["ほしふるよるのれしぴ"],
    searchKeywords: ["料理", "夜空", "恋愛"],
    audienceType: "female",
    contentType: "manga",
    creator: "天宮さくら",
    performers: [],
    maker: "リーフ出版",
    series: "レシピシリーズ",
    releaseDate: "2026-01-15",
    addedAt: "2026-03-21T09:15:00+09:00",
    updatedAt: "2026-10-05T16:40:00+09:00",
    tags: ["恋愛", "料理", "日常"],
    description:
      "夜空の見える小さな食堂で、料理を通じて人がつながっていく。一話完結の連作としても読める人気シリーズです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20nighttime%20kitchen%20artwork%20in%20deep%20teal%20and%20rose%20gold%2C%20soft%20circular%20glow%20and%20steam%20texture%2C%20warm%20tiny%20light%20dots%2C%20elegant%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0020&orientation=portrait",
    sampleVideoUrl: null,
    price: 880,
    onSale: true,
    rating: 4.6,
    reviewCount: 203,
    rankingScore: 95,
    affiliateUrl: "https://example.com/store/wk-0020",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-10-05T16:40:00+09:00",
  },
  {
    id: "WK-0021",
    title: "秘書課のひみつ",
    alternativeTitles: ["ひしょかのひみつ"],
    searchKeywords: ["秘書", "オフィス", "大人"],
    audienceType: "female",
    contentType: "ebook",
    creator: "如月あおい",
    performers: [],
    maker: "燈文庫",
    series: null,
    releaseDate: "2026-05-01",
    addedAt: "2026-06-06T13:10:00+09:00",
    updatedAt: "2026-09-09T10:25:00+09:00",
    tags: ["恋愛", "オフィス", "大人向け"],
    description:
      "仕事は完璧な秘書が、退社後だけ見せる顔。落ち着いた文章で綴られる、大人向けの短編恋愛小説です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20elegant%20artwork%20in%20muted%20taupe%20and%20dusty%20rose%2C%20thin%20geometric%20lines%20and%20soft%20fabric%20folds%2C%20subtle%20linen%20texture%2C%20refined%20minimal%20editorial%20composition%2C%20no%20text&width=600&height=800&seq=wk-0021&orientation=portrait",
    sampleVideoUrl: null,
    price: 1200,
    onSale: false,
    rating: 3.7,
    reviewCount: 28,
    rankingScore: 66,
    affiliateUrl: "https://example.com/store/wk-0021",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0022",
    title: "夏色フォトグラフ",
    alternativeTitles: ["なついろふぉとぐらふ"],
    searchKeywords: ["夏", "写真", "青春"],
    audienceType: "female",
    contentType: "video",
    creator: "早川なつみ",
    performers: ["綾瀬ひなた"],
    maker: "カナリアブックス",
    series: null,
    releaseDate: "2026-09-05",
    addedAt: "2026-10-12T11:35:00+09:00",
    updatedAt: "2026-10-12T14:05:00+09:00",
    tags: ["青春", "ドラマ", "感動"],
    description:
      "写真部の最後の夏、部員たちは一枚の写真に残したい景色を探す。光と音を丁寧に積み上げた青春ドラマです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20summer%20artwork%20with%20sunlit%20peach%20and%20soft%20mint%20tones%2C%20layered%20translucent%20light%20shapes%20and%20lens%20flare%2C%20warm%20film%20grain%2C%20bright%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0022&orientation=portrait",
    sampleVideoUrl: "https://mdn.github.io/shared-assets/videos/flower.mp4",
    price: 1980,
    onSale: false,
    rating: 4.3,
    reviewCount: 63,
    rankingScore: 86,
    affiliateUrl: "https://example.com/store/wk-0022",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0023",
    title: "50回目のプロポーズ",
    alternativeTitles: ["ごじゅっかいめのぷろぽーず"],
    searchKeywords: ["プロポーズ", "結婚", "コメディ"],
    audienceType: "female",
    contentType: "manga",
    creator: "藤崎れい",
    performers: [],
    maker: "みなも書房",
    series: null,
    releaseDate: "2026-10-10",
    addedAt: "2026-10-11T09:05:00+09:00",
    updatedAt: "2026-10-17T07:30:00+09:00",
    tags: ["恋愛", "コメディ", "長編"],
    description:
      "毎回違う方法で求婚してくる相手に、主人公が本気で困っている。テンポ重視の長編ラブコメディです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20romantic%20comedy%20artwork%20in%20ivory%20and%20rose%20petal%20pink%2C%20playful%20scattered%20circles%20and%20soft%20ribbon%20curves%2C%20light%20paper%20texture%2C%20cheerful%20minimal%20editorial%20composition%2C%20no%20text&width=600&height=800&seq=wk-0023&orientation=portrait",
    sampleVideoUrl: null,
    price: 990,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: 72,
    affiliateUrl: "https://example.com/store/wk-0023",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0024",
    title: "雨上がりのマルシェ",
    alternativeTitles: ["あめあがりのまるしぇ"],
    searchKeywords: ["市場", "写真集", "旅"],
    audienceType: "female",
    contentType: "book",
    creator: "小森ゆえ",
    performers: [],
    maker: "アトリエ・ノア",
    series: null,
    releaseDate: "2025-06-18",
    addedAt: "2026-01-15T10:00:00+09:00",
    updatedAt: "2026-05-20T15:15:00+09:00",
    tags: ["日常", "エッセイ", "写真集"],
    description:
      "雨の日の市場を歩きながら撮影した写真と短い文章の記録。静かな時間を切り取ったエッセイ風の一冊です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20market%20essay%20artwork%20in%20sage%20green%20and%20terracotta%2C%20overlapping%20soft%20rectangles%20and%20arched%20shapes%2C%20rainy%20window%20texture%2C%20calm%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0024&orientation=portrait",
    sampleVideoUrl: null,
    price: 1800,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: null,
    affiliateUrl: "https://example.com/store/wk-0024",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0025",
    title: "きみと歩く放課後",
    alternativeTitles: ["きみとあるくほうかご"],
    searchKeywords: ["放課後", "学園", "青春"],
    audienceType: "female",
    contentType: "manga",
    creator: "桜井まどか",
    performers: [],
    maker: "リーフ出版",
    series: "放課後シリーズ",
    releaseDate: "2026-04-03",
    addedAt: "2026-10-16T12:45:00+09:00",
    updatedAt: "2026-10-02T18:10:00+09:00",
    tags: ["青春", "恋愛", "学園"],
    description:
      "帰り道だけが二人の時間。少しずつ言葉を交わしながら、距離が縮まっていく学園青春ストーリーです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20golden%20hour%20school%20artwork%20in%20warm%20amber%20and%20soft%20coral%2C%20long%20horizontal%20shadow%20shapes%2C%20gentle%20dust%20texture%2C%20nostalgic%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0025&orientation=portrait",
    sampleVideoUrl: null,
    price: 550,
    onSale: false,
    rating: 4.1,
    reviewCount: 95,
    rankingScore: 80,
    affiliateUrl: "https://example.com/store/wk-0025",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0026",
    title: "大人のおとぎ話",
    alternativeTitles: ["おとなのおとぎばなし"],
    searchKeywords: ["おとぎ話", "短編集", "幻想"],
    audienceType: "female",
    contentType: "ebook",
    creator: "桐島ゆり",
    performers: [],
    maker: "燈文庫",
    series: null,
    releaseDate: "2026-10-08",
    addedAt: "2026-10-09T10:30:00+09:00",
    updatedAt: "2026-10-15T13:00:00+09:00",
    tags: ["恋愛", "ファンタジー", "大人向け"],
    description:
      "知っている童話を、大人の視線で描き直した短編集。美しい文章と、少し苦い結末が印象に残る一冊です。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20fairytale%20artwork%20in%20deep%20burgundy%20and%20dusty%20pink%2C%20ornate%20arched%20shapes%20and%20soft%20velvet%20texture%2C%20moody%20warm%20light%2C%20elegant%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0026&orientation=portrait",
    sampleVideoUrl: null,
    price: 1100,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: 75,
    affiliateUrl: "https://example.com/store/wk-0026",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0027",
    title: "境界線のアトリエ",
    alternativeTitles: ["きょうかいせんのあとりえ"],
    searchKeywords: ["同人誌", "イラスト", "アトリエ"],
    audienceType: "male",
    contentType: "doujin",
    creator: "灰谷そら",
    performers: [],
    maker: "サークル灰",
    series: null,
    releaseDate: "2026-09-18",
    addedAt: "2026-10-05T09:40:00+09:00",
    updatedAt: "2026-10-06T11:20:00+09:00",
    tags: ["同人誌", "アート", "短編集"],
    description:
      "静かなアトリエで交わされる短い会話を、線の強弱だけで描いた自主制作の短編集です。初出の同人誌に描き下ろしを加えた一冊。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20atelier%20artwork%20in%20warm%20greige%20and%20muted%20olive%2C%20layered%20sketch%20lines%20and%20paper%20texture%2C%20soft%20window%20light%2C%20quiet%20minimal%20editorial%20illustration%20with%20generous%20negative%20space%2C%20no%20text&width=600&height=800&seq=wk-0027&orientation=portrait",
    sampleVideoUrl: null,
    price: 1320,
    onSale: false,
    rating: 4.0,
    reviewCount: 21,
    rankingScore: null,
    affiliateUrl: "https://example.com/store/wk-0027",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0028",
    title: "星屑カフェへようこそ",
    alternativeTitles: ["ほしくずかふぇへようこそ"],
    searchKeywords: ["ノベルゲーム", "カフェ", "星"],
    audienceType: "female",
    contentType: "game",
    creator: "星見あかり",
    performers: ["涼森ひな"],
    maker: "ステラワークス",
    series: "星屑カフェ",
    releaseDate: "2026-08-14",
    addedAt: "2026-10-08T10:15:00+09:00",
    updatedAt: "2026-10-16T09:30:00+09:00",
    tags: ["恋愛", "カフェ", "ノベルゲーム"],
    description:
      "閉店間際のカフェで、夜空のメニューだけを頼む客と店員の物語。選択によって会話の温度が変わる、短編のノベルゲームです。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20starry%20cafe%20artwork%20in%20dusty%20rose%20and%20deep%20teal%2C%20rounded%20geometric%20light%20shapes%20and%20soft%20glow%20dots%2C%20warm%20linen%20texture%2C%20calm%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0028&orientation=portrait",
    sampleVideoUrl: null,
    price: 3800,
    onSale: false,
    rating: 4.2,
    reviewCount: 47,
    rankingScore: 87,
    affiliateUrl: "https://example.com/store/wk-0028",
    sourceName: "ユメサーチ編集部",
    sourceUpdatedAt: "2026-10-16T09:30:00+09:00",
  },
  {
    id: "WK-0029",
    title: "蒼穹のカナタ アクリルスタンド",
    alternativeTitles: ["そうきゅうのかなた あくりるすたんど"],
    searchKeywords: ["グッズ", "アクリルスタンド", "蒼穹"],
    audienceType: "common",
    contentType: "goods",
    creator: "蒼流社",
    performers: [],
    maker: "蒼流社",
    series: "蒼穹シリーズ",
    releaseDate: "2026-09-01",
    addedAt: "2026-10-16T10:00:00+09:00",
    updatedAt: "2026-10-16T10:00:00+09:00",
    tags: ["グッズ", "コレクション"],
    description:
      "「蒼穹のカナタ」の一場面を切り取ったアクリルスタンドです。背景は透明で、台座は落ち着いた生成り色。デスク周りに置きやすいサイズにまとめました。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20product%20artwork%20of%20a%20transparent%20acrylic%20stand%20on%20a%20soft%20cream%20background%2C%20pale%20blue%20and%20sand%20geometric%20shapes%2C%20gentle%20shadow%2C%20clean%20minimal%20product%20photography%20style%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0029&orientation=portrait",
    sampleVideoUrl: null,
    price: 1650,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: null,
    affiliateUrl: "https://example.com/store/wk-0029",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0030",
    title: "夜明けのスケッチブック",
    alternativeTitles: ["よあけのすけっちぶっく"],
    searchKeywords: ["スケッチ", "短編集", "区分未設定"],
    audienceType: "unclassified",
    contentType: "book",
    creator: "未登録",
    performers: [],
    maker: "みなも書房",
    series: null,
    releaseDate: "2026-10-16",
    addedAt: "2026-10-17T06:00:00+09:00",
    updatedAt: "2026-10-17T06:00:00+09:00",
    tags: ["短編集"],
    description:
      "外部データ取り込み直後の状態を再現したデモレコードです。対象ユーザー区分と公式ジャンルが未設定のため、通常の一覧には表示されません。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20sketchbook%20artwork%20in%20soft%20grey%20and%20pale%20amber%2C%20loose%20pencil%20line%20shapes%20on%20textured%20paper%2C%20early%20morning%20light%2C%20quiet%20minimal%20editorial%20illustration%2C%20no%20text&width=600&height=800&seq=wk-0030&orientation=portrait",
    sampleVideoUrl: null,
    price: 1200,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: null,
    affiliateUrl: "https://example.com/store/wk-0030",
    sourceName: null,
    sourceUpdatedAt: null,
  },
  {
    id: "WK-0031",
    title: "凍てつく街の灯",
    alternativeTitles: ["いてつくまちのあかり"],
    searchKeywords: ["冬", "近未来", "発売予定", "デモ"],
    audienceType: "male",
    contentType: "video",
    creator: "氷室透",
    performers: ["冬木涼", "宮下灯"],
    maker: "蒼流社",
    series: null,
    releaseDate: "2026-11-20",
    addedAt: "2026-10-16T09:00:00+09:00",
    updatedAt: "2026-10-17T08:45:00+09:00",
    tags: ["SF", "ドラマ", "発売予定"],
    description:
      "発売予定作品の表示確認用デモレコードです。凍えそうな街で、消えかけた街灯を守る二人の一日を描きます。実際の商品情報ではありません。",
    thumbnailUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20wintry%20city%20artwork%20in%20pale%20ice%20blue%20and%20warm%20amber%2C%20geometric%20building%20silhouettes%20with%20a%20single%20glowing%20lamp%2C%20cold%20frost%20texture%2C%20quiet%20minimal%20editorial%20illustration%20with%20clean%20simple%20background%2C%20no%20text&width=600&height=800&seq=wk-0031&orientation=portrait",
    sampleVideoUrl: null,
    price: 2200,
    onSale: false,
    rating: null,
    reviewCount: null,
    rankingScore: null,
    affiliateUrl: "https://example.com/store/wk-0031",
    sourceName: null,
    sourceUpdatedAt: null,
  },
];